import React from 'react';

function SimpleButton({
	tag,
	colors,
	onClick,

	/* OPTIONAL PROPOS */
	loading,
	disabled,
	fillMode = true,
	negativeMode,
	styleBTN,
	styleFill,
	classNameBTN = 'px-10 cursor-pointer py-4 focus:outline-none text-sm md:text-lg bold rounded-md md:w-max w-full',
	styleDisabled,
	classNameTXT,
	styleSPAN,
}) {
	/* Variable that checks if any point of the component is being hovered so style can be applied to the Box */
	const [hover, setHover] = React.useState(false);

	/* Default values for the styles */ // FILL TRUE && NEGTIVE TRUE
	const defaultStyleBTN = {
		border: `1px solid ${negativeMode ? colors?.secondary : colors?.primary}`,
		backgroundColor: hover && (negativeMode ? colors?.primary : colors?.light),
		color: negativeMode ? colors?.secondary : colors?.text,
		transition: 'all 200ms ease-in',
	};
	const defaultStyleFill = {
		backgroundColor: hover ? colors?.light : colors?.primary,
		color: hover ? colors?.primary : colors?.secondary,
		boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
		transition: 'all 200ms ease-in-out',
	};
	const defaultStyleFillNegative = {
		backgroundColor: hover ? colors?.primary : colors?.light,
		color: hover ? colors?.secondary : colors?.primary,
		boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
		transition: 'all 200ms ease-in-out',
	};
	const defaultStyleDisabled = {
		backgroundColor: colors?.deactivated,
		color: colors?.secondary,
		transition: 'all 200ms ease-in-out',
		cursor: loading ? 'wait' : 'pointer',
	};
	const defaultStyleSPAN = {
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideStyleFill = { ...(negativeMode ? defaultStyleFillNegative : defaultStyleFill), ...styleFill };
	const overrideStyleBTN = { ...(fillMode ? overrideStyleFill : defaultStyleBTN), ...styleBTN };
	const overrideStyleDisabled = { ...defaultStyleDisabled, ...styleDisabled };
	const overrideStyleSPAN = { ...defaultStyleSPAN, ...styleSPAN };

	/* Mouseover Styling */
	const onMouseOver = () => setHover(true);
	const onMouseLeave = () => setHover(false);

	return <button
		className={classNameBTN}
		onClick={onClick}
		style={disabled ? overrideStyleDisabled : overrideStyleBTN}
		onMouseOver={onMouseOver}
		onMouseLeave={onMouseLeave}
		type = "button"
	>
		<span className={classNameTXT} style={overrideStyleSPAN}>
			{tag}
		</span>
	</button>;
}

export default SimpleButton;
